module.exports = __webpack_public_path__ + "img/cources-img.eab9ada3.jpg";